'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateWithSelectors = undefined;

var _ramda = require('ramda');

exports.default = function () {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  if (fns.length === 0) return;

  var ps = (0, _ramda.init)(fns);
  var f = (0, _ramda.last)(fns);

  var args = null;
  var cache = null;

  return function (s) {
    var newArgs = ps.length === 0 ? [s] : ps.map(function (x) {
      return x(s);
    });
    if (!args || (0, _ramda.range)(0, args.length).some(function (i) {
      return args[i] !== newArgs[i];
    })) {
      args = newArgs;
      cache = f.apply(null, args);
    }

    return cache;
  };
};

var mapStateWithSelectors = exports.mapStateWithSelectors = function mapStateWithSelectors(m) {
  return function (s) {
    return (0, _ramda.fromPairs)(Object.keys(m).map(function (x) {
      return [x, m[x](s)];
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// D:/Code/Lynqu/npm/no-redux/dist/selector.js
// module id = 411
// module chunks = 0